var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_22137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.66667H15V0H13.3333V1.66667H6.66667V0H5V1.66667H2.5C1.83696 1.66667 1.20107 1.93006 0.732233 2.3989C0.263392 2.86774 0 3.50363 0 4.16667L0 20H20V4.16667C20 3.50363 19.7366 2.86774 19.2678 2.3989C18.7989 1.93006 18.163 1.66667 17.5 1.66667ZM1.66667 4.16667C1.66667 3.94565 1.75446 3.73369 1.91074 3.57741C2.06702 3.42113 2.27899 3.33333 2.5 3.33333H17.5C17.721 3.33333 17.933 3.42113 18.0893 3.57741C18.2455 3.73369 18.3333 3.94565 18.3333 4.16667V6.66667H1.66667V4.16667ZM1.66667 18.3333V8.33333H18.3333V18.3333H1.66667Z",
    fill: "#134A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 10.8333H12.5V12.5H14.1667V10.8333Z",
    fill: "#134A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 10.8333H9.16675V12.5H10.8334V10.8333Z",
    fill: "#134A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49991 10.8333H5.83325V12.5H7.49991V10.8333Z",
    fill: "#134A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.1667H12.5V15.8334H14.1667V14.1667Z",
    fill: "#134A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 14.1667H9.16675V15.8334H10.8334V14.1667Z",
    fill: "#134A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49991 14.1667H5.83325V15.8334H7.49991V14.1667Z",
    fill: "#134A70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_22137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9cc99900e1bd903c462840524dda274d.svg";
export { ForwardRef as ReactComponent };